module.exports = __webpack_public_path__ + "static/media/sad-blue.6599eb74.png";


//////////////////
// WEBPACK FOOTER
// ./src/nagatrons/sad-blue.png
// module id = 186
// module chunks = 0